import { apply, nodeMatrix } from '@repo/design-renderer';
import type { ReactElement } from 'react';
import type { BoxNode, FlatView } from '@/features/design-editor';

interface TextEditHintProps {
  readonly node: BoxNode;
  readonly view: FlatView;
}

/** 선택한 텍스트 바로 아래의 작은 안내 — 더블클릭하면 글자를 고칠 수 있다고 알린다(회전을 반영한 아래 끝 기준). */
export const TextEditHint = ({ node, view }: TextEditHintProps): ReactElement => {
  const m = nodeMatrix(node);
  const corners = [
    { x: 0, y: 0 },
    { x: node.width, y: 0 },
    { x: node.width, y: node.height },
    { x: 0, y: node.height },
  ].map((corner) => apply(m, corner));
  const centerX = corners.reduce((sum, c) => sum + c.x, 0) / corners.length;
  const bottom = Math.max(...corners.map((c) => c.y));
  return (
    <p
      data-testid="text-edit-hint"
      className="pointer-events-none absolute -translate-x-1/2 rounded-full bg-foreground/85 px-2.5 py-1 text-[11px] font-medium whitespace-nowrap text-background shadow-sm"
      style={{
        left: view.offsetX + centerX * view.pxPerMmX,
        top: view.offsetY + bottom * view.pxPerMmY + 12,
      }}
    >
      더블클릭해서 글자 고치기
    </p>
  );
};
